import { graphql } from "@apollo/client/react/hoc"
import produce from "immer"
import compose from "lodash/flowRight"
import { DeletePathItemDocument, PathDocument } from "../../api/generated"
import { getPathItems } from "../graphql/withPathItems"
import withPathQueryVariables from "../graphql/withPathQueryVariables"
import withReorderPathItems from "../graphql/withReorderPathItems"

export default compose(
  withPathQueryVariables,
  withReorderPathItems,
  graphql(DeletePathItemDocument, {
    props: ({ mutate, ownProps }) => ({
      deletePathItem: async (pathItem) =>
        await mutate({
          variables: {
            path_id: pathItem.path_id,
            id: pathItem.source_id
          },
          update: (cache, result) => {
            const query = PathDocument
            const variables = ownProps.pathQueryVariables
            const data = cache.readQuery({ query, variables })
            const nextData = produce(data, (draft) => {
              const deletedItem = pathItem

              if (deletedItem) {
                const findItemIndex = (item) =>
                  draft.path.items.edges.findIndex(
                    (_edge) => _edge.node.id == item.id
                  )

                const indices = draft.path.items.edges
                  .filter((edge) => edge.node.parent_id == deletedItem.id)
                  .map((edge) => findItemIndex(edge.node))

                indices.push(findItemIndex(deletedItem))
                // remove from root path items
                indices
                  .sort((indexA, indexB) => indexB - indexA) // sort hight -> low since we're splicing and each splice changes the items' indices
                  .forEach((index) => draft.path.items.edges.splice(index, 1))
              }
            })
            // remove item from path
            cache.writeQuery({ query, variables, data: nextData })

            // update path item orders
            const updatedData = cache.readQuery({ query, variables })
            ownProps.reorderPathItems(getPathItems(updatedData))
          }
        })
    })
  })
)
